export const MuiButtonBase = (palette) => ({
    root: {
        '&:focus-visible': {
            outline: `solid 2px ${palette.semantic.colorForegroundEmp}`,
            backgroundColor: palette.semantic.colorIconButtonFocus,
        },
        '&:active': { backgroundColor: palette.semantic.colorIconButtonPressed },
    },
});
